import { EObjectType, IGenplan } from '@cian/countryside-genplan-component';
import * as R from 'ramda';

import { IState } from '../../store';

export const selectGenplan = ({ genplan }: IState): IGenplan | null => {
  if (!genplan || !genplan.image || !genplan.objects) {
    return null;
  }

  return {
    image: genplan.image,
    objects: genplan.objects.map(({ coordinates, cianId, objectType, uniqName }) => {
      const xCoords = coordinates.map(({ x }) => x);
      const yCoords = coordinates.map(({ y }) => y);

      return {
        id: cianId,
        polygonPath: coordinates.map(({ x, y }) => `${x} ${y}`).join(' '),
        center: [R.sum(xCoords) / xCoords.length, R.sum(yCoords) / yCoords.length],
        objectType,
        uniqName,
      };
    }),
    filters: genplan.objects.reduce<EObjectType[]>(
      (result, { objectType }) => (objectType && !result.includes(objectType) ? [...result, objectType] : result),
      [],
    ),
  };
};
